import { CustomToastService } from '../_services/custom-toast.service';

// Global reference to the custom toast service
let customToastServiceInstance: CustomToastService | null = null;

export function setCustomToastService(service: CustomToastService) {
  customToastServiceInstance = service;
}

export function showNotification(type, message, toastr: any, timeOut = 5000): void {
  // Use the global instance if available, otherwise fallback to toastr
  if (customToastServiceInstance) {
    switch (type) {
      case 'default':
        customToastServiceInstance.info(message, 'Notification', timeOut);
        break;
      case 'danger':
        customToastServiceInstance.error(message, 'Error', timeOut);
        break;
      case 'success':
        customToastServiceInstance.success(message, 'Success', timeOut);
        break;
      case 'warning':
        customToastServiceInstance.warning(message, 'Warning', timeOut);
        break;
      case 'info':
        customToastServiceInstance.info(message, 'Info', timeOut);
        break;
      default:
        customToastServiceInstance.info(message, 'Notification', timeOut);
    }
  } else {
    // Fallback to the wrapper service
    switch (type) {
      case 'default':
        toastr.info(message, 'Notification', { timeOut });
        break;
      case 'danger':
        toastr.error(message, 'Error', { timeOut });
        break;
      case 'success':
        toastr.success(message, 'Success', { timeOut });
        break;
      case 'warning':
        toastr.warning(message, 'Warning', { timeOut });
        break;
      case 'info':
        toastr.info(message, 'Info', { timeOut });
        break;
      default:
        toastr.info(message, 'Notification', { timeOut });
    }
  }
}



// export function showNotification(type, message, toastr, timeOut = 5000) {
//   const color = Math.floor(Math.random() * 5 + 1);
//   if (type === 'default') {
//     toastr.show(
//       `<span class="alert-icon ni ni-bell-55" data-notify="icon"></span> <div class="alert-text"</div> <span class="alert-title" data-notify="title">Ngx Toastr</span> <span data-notify="message">${message}</span></div>`,
//       '',
//       {
//         timeOut: timeOut,
//         closeButton: true,
//         enableHtml: true,
//         tapToDismiss: false,
//         titleClass: 'alert-title',
//         positionClass: 'toast-top-center',
//         toastClass:
//           'ngx-toastr alert alert-dismissible alert-default alert-notify'
//       }
//     );
//   }
//   if (type === 'danger') {
//     toastr.show(
//       `<span class="alert-icon ni ni-bell-55" data-notify="icon"></span> <div class="alert-text"</div> <span class="alert-title" data-notify="title">Error</span> <span data-notify="message">${message}</span></div>`,
//       '',
//       {
//         timeOut: timeOut,
//         closeButton: true,
//         enableHtml: true,
//         tapToDismiss: false,
//         titleClass: 'alert-title',
//         positionClass: 'toast-top-center',
//         toastClass:
//           'ngx-toastr alert alert-dismissible alert-danger alert-notify'
//       }
//     );
//   }
//   if (type === 'success') {
//     toastr.show(
//       `<span class="alert-icon ni ni-bell-55" data-notify="icon"></span> <div class="alert-text"</div> <span class="alert-title" data-notify="title">Success</span> <span data-notify="message">${message}</span></div>`,
//       '',
//       {
//         timeOut: timeOut,
//         closeButton: true,
//         enableHtml: true,
//         tapToDismiss: false,
//         titleClass: 'alert-title',
//         positionClass: 'toast-top-center',
//         toastClass:
//           'ngx-toastr alert alert-dismissible alert-success alert-notify'
//       }
//     );
//   }
//   if (type === 'warning') {
//     toastr.show(
//       '<span class="alert-icon ni ni-bell-55" data-notify="icon"></span> <div class="alert-text"</div> <span class="alert-title" data-notify="title">Ngx Toastr</span> <span data-notify="message">Turning standard Bootstrap alerts into awesome notifications</span></div>',
//       '',
//       {
//         timeOut: timeOut,
//         closeButton: true,
//         enableHtml: true,
//         tapToDismiss: false,
//         titleClass: 'alert-title',
//         positionClass: 'toast-top-center',
//         toastClass:
//           'ngx-toastr alert alert-dismissible alert-warning alert-notify'
//       }
//     );
//   }
//   if (type === 'info') {
//     toastr.show(
//       '<span class="alert-icon ni ni-bell-55" data-notify="icon"></span> <div class="alert-text"</div> <span class="alert-title" data-notify="title">Ngx Toastr</span> <span data-notify="message">Turning standard Bootstrap alerts into awesome notifications</span></div>',
//       '',
//       {
//         timeOut: timeOut,
//         closeButton: true,
//         enableHtml: true,
//         tapToDismiss: false,
//         titleClass: 'alert-title',
//         positionClass: 'toast-top-center',
//         toastClass:
//           'ngx-toastr alert alert-dismissible alert-info alert-notify'
//       }
//     );
//   }
// }
